/**
 * 图片添加水印
 * @param {*} url 图片地址
 * @param {*} text 水印文字
 */
export function addWatermark({ // 1
    url = '',
    address,
    lat,
    time,
    callback = null,
}) {
    const img = new Image(); // 2
    img.src = url;
    img.crossOrigin = 'anonymous';  // 3
    img.onload = function () {
        let maxWidth = 300;
        let maxHight = (img.height / img.width) * maxWidth
        const canvas = document.createElement('canvas');
        canvas.width = maxWidth;  // 4
        canvas.height = maxHight;
        console.log('宽', img.width, '高', img.height, maxWidth, maxHight)
        const ctx = canvas.getContext('2d');

        ctx.drawImage(img, 0, 0, maxWidth, maxHight);

        ctx.font = "15px 宋体"
        ctx.fillStyle = "#fff"
        // 设置右对齐
        ctx.textAlign = 'right'
        ctx.fillText(time, canvas.width - 20, canvas.height - 70);
        ctx.fillText(lat, canvas.width - 20, canvas.height - 50);
        // ctx.fillText(address, canvas.width - 20, canvas.height - 20);
        drawtext(ctx,address,canvas.width - 20, canvas.height - 45,canvas.width - 20)
        let base64Url = '';
        base64Url = canvas.toDataURL("image/jpeg", 0.9); // 6
        callback && callback(base64Url); // 7
    }
}

/*
str:要绘制的字符串
canvas:canvas对象
initX:绘制字符串起始x坐标
initY:绘制字符串起始y坐标
lineHeight:字行高
*/
function drawtext(ctx,t,x,y,w){
    //参数说明
    //ctx：canvas的 2d 对象，t：绘制的文字，x,y:文字坐标，w：文字最大宽度
    let chr = t.split("")
    let temp = ""
    let row = []

    for (let a = 0; a<chr.length;a++){
        if( ctx.measureText(temp).width < w && ctx.measureText(temp+(chr[a])).width <= w){
            temp += chr[a];
        }else{
            row.push(temp);
            temp = chr[a];
        }
    }
    row.push(temp)
    for(let b=0;b<row.length;b++){
        ctx.fillText(row[b],x,y+(b+1)*20);//每行字体y坐标间隔20
    }

}

